import {
  Box,
  ButtonGroup,
  Heading,
  HStack,
  Icon,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useState, useCallback } from 'react';
import { RiAddLine } from 'react-icons/ri';
import { LinkButton } from '../../../../components/LinkButton';
import { useAuth } from '../../../../hooks/auth';
import { DefaultLayout } from '../../_layout/DefaultLayout';
import { AppointmentList } from './Appointments/AppointmentList';
import { ProductList } from './Products/ProductList';

export const ProductsAndServices = (): JSX.Element => {
  const { assignment: authenticatedAssignment } = useAuth();

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <DefaultLayout>
      <Box flex="1" borderRadius={8} bg="white" p="8">
        <HStack justify="space-between">
          <Heading size="lg" fontWeight="normal">
            Produtos e Serviços
          </Heading>

          <ButtonGroup>
            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              ['APPOINTMENT_FULL_ACCESS', 'APPOINTMENT_WRITE_ACCESS'].includes(
                feature.key,
              ),
            ) && (
              <LinkButton
                colorScheme="green"
                size="sm"
                icon={<Icon as={RiAddLine} fontSize="16" />}
                to="/services/appointments/management"
              >
                Cadastrar ordem de serviço
              </LinkButton>
            )}

            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              ['PRODUCT_FULL_ACCESS', 'PRODUCT_WRITE_ACCESS'].includes(
                feature.key,
              ),
            ) && (
              <LinkButton
                colorScheme="green"
                size="sm"
                icon={<Icon as={RiAddLine} fontSize="16" />}
                to="/services/products/register"
              >
                Cadastrar produto
              </LinkButton>
            )}
          </ButtonGroup>
        </HStack>

        <Tabs
          mt="8"
          index={tabIndex}
          onChange={handleTabChanges}
          variant="enclosed-colored"
          isLazy
        >
          <TabList>
            <Tab>Ordens de serviço</Tab>

            <Tab>Produtos</Tab>
          </TabList>

          <TabPanels mt="4">
            <TabPanel>
              <AppointmentList />
            </TabPanel>

            <TabPanel>
              <ProductList />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </DefaultLayout>
  );
};
